var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('FormTitleText',{attrs:{"titleText":"区分"}}),(_vm.rules && _vm.rules.includes('required'))?_c('RequiredIcon'):_vm._e()],1),_c('p',[_vm._v(_vm._s(_vm.computedCategory))])])}
var staticRenderFns = []

export { render, staticRenderFns }